import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const ModalBody = forwardRef<HTMLDivElement, BSDiv>(
  ({ className = "", children, ...props }, ref) => (
    <div {...props} className={`modal-body ${className}`} ref={ref}>
      {children}
    </div>
  )
);